import { createIcon } from '@chakra-ui/react';

export const DeveloperBoldIcon = createIcon({
  displayName: 'DeveloperBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M5.20703 2.3335H10.7939C11.9079 2.3335 12.737 2.66353 13.2861 3.21338C13.8352 3.76314 14.1642 4.59199 14.1611 5.70557V11.2935C14.1611 12.4074 13.8304 13.2365 13.2803 13.7866C12.7301 14.3367 11.901 14.6665 10.7871 14.6665H5.20703C4.09331 14.6664 3.26486 14.3363 2.71484 13.7856C2.16471 13.2348 1.83398 12.4042 1.83398 11.2866V5.70654C1.83404 4.59279 2.16379 3.76346 2.71387 3.21338C3.26395 2.6633 4.09328 2.33355 5.20703 2.3335ZM7.10742 5.77979C6.71881 5.39133 6.08191 5.39124 5.69336 5.77979L4.03418 7.43994C3.44558 8.02854 3.44558 8.9783 4.03418 9.56689L5.69336 11.2271C5.892 11.4257 6.14836 11.52 6.40039 11.52C6.62101 11.52 6.84469 11.4476 7.03027 11.2964L7.10742 11.2271C7.49602 10.8385 7.49602 10.2016 7.10742 9.81299L5.7998 8.50049L7.10742 7.19385C7.49602 6.80525 7.49602 6.16838 7.10742 5.77979ZM10.3076 5.77295C9.91903 5.3845 9.28211 5.38445 8.89355 5.77295C8.50549 6.16101 8.50557 6.79632 8.89258 7.18506V7.18604L10.2002 8.49951L8.89355 9.80615C8.50502 10.1947 8.50515 10.8316 8.89355 11.2202C9.09225 11.4189 9.34849 11.5132 9.60059 11.5132C9.8527 11.5132 10.1089 11.4189 10.3076 11.2202L11.9678 9.56006L11.9668 9.55908C12.5578 8.97454 12.5536 8.01892 11.9678 7.43311L10.3076 5.77295Z"
          fill="#391CAD"
          stroke="#391CAD"
        />
      </svg>
    </>
  ),
});
